/** Postgres `INTEGER` ceiling — the bound every INT4 column shares (~24.8 days as ms). */
export const MAX_INT4 = 2_147_483_647;
